/** IP from last guest login (`/AX/login`); used for RecordAccess without third-party lookups. */
const IP_STORAGE_KEY = 'ipAddress';

export function readStoredClientIp(): string | undefined {
  return localStorage.getItem(IP_STORAGE_KEY) ?? undefined;
}
